// Minimal heart + sound wave brand mark as inline SVG.
// Stroked vector — scales perfectly and stays crisp at any size.
export default function HeartWaveMark({ className = "w-6 h-6", strokeWidth = 1.6 }) {
  return (
    <svg
      viewBox="0 0 64 60"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Heart outline */}
      <path d="M32 54 C 8 38, 4 22, 14 14 C 22 7, 30 12, 32 18 C 34 12, 42 7, 50 14 C 60 22, 56 38, 32 54 Z" />
      {/* Sound wave inside */}
      <path d="M10 33 H 18 L 22 27 L 26 39 L 30 22 L 34 41 L 38 30 L 42 35 L 46 31 H 56" />
    </svg>
  );
}
